import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  editButtonLabel: {
    id: 'CFs0ey',
    defaultMessage: 'Edit',
    description: 'Label for a link that switches a WWEX registration summary section into an editable form',
  },
  hasErrorTooltip: {
    id: 'IRmnV1',
    defaultMessage: 'This section has an error. Edit to fix it.',
    description: 'Tooltip shown on the error badge next to an Edit link when that section has a validation error',
  },
});
